<template>
  <el-card
    v-loading="loading"
    class="card-container"
    shadow="never"
  >
    <el-row
      v-if="contractInfo"
      slot="header"
      type="flex"
      justify="space-between"
      align="middle"
    >
      <el-row
        type="flex"
        align="middle"
      >
        <div>
          <h3 class="m-0">
            {{ contractInfo.translations.vi.name }}
          </h3>
          <p class="m-0 mt-xs">{{ contractInfo.translations.vi.description }}</p>
        </div>
      </el-row>
      <div>
        <el-row
          type="flex"
          justify="center"
        >
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            disabled
            @click="() => formVisible = true"
          >
            Chỉnh sửa
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            disabled
            @click="handleDelete"
          >
            Xóa
          </el-button>
        </el-row>
      </div>
    </el-row>
    <el-row
      v-if="contractInfo"
      :gutter="12"
    >
      <el-col
        :lg="24"
        :span="24"
        class="mb-m"
      >
        <Steps
          :contract-statuses="contractStatuses"
        />
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import Steps from "./components/detail/steps.vue";

import contractServices from "@/services/contract";
import contractStatusServices from "@/services/contract-status";
import { notification } from "@/utils/common";

export default {
  name: "ConfigDetail",
  components: {
    Steps,
  },
  data() {
    return {
      loading: false,
      formVisible: false,
      contractInfo: null,
      roleTotal: 0,
      contractStatuses: []
    };
  },
  beforeMount() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      contractServices
        .fetchById(this.$route.params.id)
        .then((response) => {
          this.contractInfo = response;
          this.loading = false;
          this.loadContractStatuses(response.organization_id)
        })
        .catch(() => {
          this.$router.push({ name: "Contracts" });
        });
    },
    loadContractStatuses(organizationId) {
      contractStatusServices
        .list({
          offset: 0,
          limit: 999,
          locale: "vi",
          filters: {
            organization_id: organizationId
          }
        })
        .then((response) => {
          this.contractStatuses = response
            .map((i) => (i.switching_statuses || []).map((s) => ({ ...s, name: s.translations?.vi?.name || s.menu || s.label })))
            .flat();
        })
        .catch(() => {
          this.contractStatuses = []
        });
    },
    changeRoleTotal(value) {
      this.roleTotal = value;
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        contractServices
          .remove(item)
          .then(() => {
            this.$router.push({ name: "Contracts" })
            notification(this, "success", "delete", "tổ chức");
          })
          .catch(() => {
            notification(this, "error", "delete", "tổ chức");
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.org-logo {
  width: 64px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
  cursor: pointer;
  border: 1px solid #409eff;
}
</style>
